import Chip from '@precis-digital/kurama/Chip'
import { type ThemeColor } from '@precis-digital/kurama/theme'
import { type EventHandler, type ReactElement, type Ref } from 'react'
import AlertTooltip, { type TooltipPropsWithAlert } from 'shared/components/Alert/AlertTooltip'
import { getChartBadgeProps, type ChartBadgeProps } from './ChartBadge'

interface ChartChipProps extends Omit<ChartBadgeProps, 'color'> {
  color?: ThemeColor
  label: string
  onDelete?: EventHandler<any>
  ref?: Ref<HTMLDivElement>
}

const ChartChip = ({
  chartType,
  label,
  color,
  pattern,
  variant = 'lighter',
  onDelete,
  ref,
  ...tooltipProps
}: ChartChipProps & TooltipPropsWithAlert): ReactElement => {
  const badgeProps = color == null ? undefined : getChartBadgeProps({ chartType, color, pattern, variant })

  const { alert, alertText } = tooltipProps
  const resolvedAlert = alert ?? (alertText != null && alertText !== '' ? 'warning' : undefined)

  return (
    <Chip
      label={label}
      badgeProps={badgeProps}
      rightAdornment={resolvedAlert != null ? <AlertTooltip {...tooltipProps} alert={resolvedAlert} /> : undefined}
      onDelete={onDelete}
      ref={ref}
    />
  )
}

export default ChartChip
